import { IconRepeat, IconUser } from '@tabler/icons-react'

import { RecurringAssignmentCreation } from '~/app/pages/SurgeonScheduler/StaffingPlanAutofill/RecurringAssignments/Creation/RecurringAssignmentCreation'
import { RecurringAssignmentList } from '~/app/pages/SurgeonScheduler/StaffingPlanAutofill/RecurringAssignments/RecurringAssignmentList'
import { AstraDialog, AstraIcon } from '~/astra'
import { DialogBreadcrumbsHeader } from '~/components'
import { Practitioner } from '~/storm'
import { useActiveRecurringAssignments } from '~/storm/common/recurringAssignments'

import { PopoverContentWrapper } from './PopoverContentWrapper'

type Props = {
    practitioner: Practitioner
}

export const RecurringAssignmentPopoverContent = ({ practitioner }: Props) => {
    const recurringAssignments = useActiveRecurringAssignments({ practitioner_id: practitioner.id })

    return (
        <PopoverContentWrapper>
            <RecurringAssignmentList recurringAssignments={recurringAssignments} />
        </PopoverContentWrapper>
    )
}

const TITLE = 'Ny regel'
export const RecurringAssignmentPractitionerCreationDialog = ({ onBackClick, practitioner }: { onBackClick: () => void; practitioner: Practitioner }) => (
    <AstraDialog
        align="top"
        isOpen
        title={TITLE}
        disableOutsideClick
        onCloseDialog={() => onBackClick()}
        header={
            <DialogBreadcrumbsHeader
                onBackClick={onBackClick}
                crumbs={[
                    {
                        title: practitioner.short_name,
                        icon: <AstraIcon icon={IconUser} />,
                        onClick: onBackClick,
                    },
                    {
                        title: TITLE,
                        icon: <AstraIcon icon={IconRepeat} />,
                    },
                ]}
            />
        }
    >
        <RecurringAssignmentCreation practitioner={practitioner} onBackClick={onBackClick} />
    </AstraDialog>
)
